import * as React from 'react';

import { Navigate } from 'react-router';

import { PMLogoIcon } from '@icons';
import { ROUTES } from '@utils/routes.ts';

import com2Logo from '@assets/images/logos/com2_logo.png';
import johnnyLogo from '@assets/images/logos/johnny_logo.webp';
import nomadLogo from '@assets/images/logos/nomad_logo.webp';


import { useQueryGetMe } from '@hooks/api/user/use-query-me.ts';

import { config } from '@/config.ts';

import * as Styled from './private-route.styled';

const isRockets = config.BRAND === 'rockets';
const isNomad = config.BRAND === 'nomad';
const isNgu3 = config.BRAND === 'ngu3';
const isCom2 = config.BRAND === 'com2';

type OwnProps = {
	children: React.ReactNode;
};

const PrivateRoute: React.FC<OwnProps> = ({ children }) => {
	const { data: userData, isLoading } = useQueryGetMe();

	const isAuthenticated = !!userData?.pm_id;

	if (isLoading) {
		return (
			<Styled.Loader>
				{isRockets ? (
					<Styled.IconWrapper>
						<PMLogoIcon />
					</Styled.IconWrapper>
				) : isNomad ? (
					<Styled.IconWrapper>
						<img src={nomadLogo} alt='nomad-logo' />
					</Styled.IconWrapper>
				) : isNgu3 ? (
					<Styled.IconWrapper>
						<img src={johnnyLogo} alt='johnny-logo' />
					</Styled.IconWrapper>
				) : isCom2 ? (
					<Styled.IconWrapper>
						<img src={com2Logo} alt='viphouse-logo' />
					</Styled.IconWrapper>
				) : (
					<Styled.IconWrapper>
						<PMLogoIcon />
					</Styled.IconWrapper>
				)}
			</Styled.Loader>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to={ROUTES.HOME} />;
	}
	return <>{children}</>;
};

export default PrivateRoute;
